<div class="container">
    <div
        *ngIf="inEditMode"
        class="delete-icon-container"
        (click)="removeItem(); $event.stopPropagation()"
    >
        <mat-icon svgIcon="delete" class="delete-icon" />
    </div>
    <div class="indicator-container">
        <div class="indicator">
            <div
                class="graph"
                [style.backgroundColor]="getBarGraphColor()"
            ></div>
        </div>
    </div>
    <div class="text-container">
        <div
            data-cy="custom-indicator-graph-status"
            class="channel-status"
            [style.color]="getBarGraphColor()"
        >
            {{ statusString | translate }}
        </div>
        <div class="channel-data">
            <span
                data-cy="custom-indicator-graph-value"
                class="channel-value"
                [style.color]="getBarGraphColor()"
                >{{ channelValue ? channelValue : 0 }}</span
            >
            <span data-cy="custom-indicator-graph-unit" class="channel-unit">{{
                channel.opsData.measurementUnit
            }}</span>
        </div>
        <div data-cy="custom-indicator-graph-title" class="channel-title">
            {{ channel.opsData.name }}
        </div>
    </div>
</div>
